/* Multi Language Gita section - add to cart + in-button quantity stepper */

(function () {
  'use strict';

  var ADD_BTN_HTML =
    '<button type="button" class="mlg-btn mlg-btn-outline mlg-btn-add" data-mlg-add>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' +
        '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
        '<path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>' +
      '</svg>' +
      '<span>Add to Cart</span>' +
    '</button>';

  function stepperHtml(qty) {
    return (
      '<div class="mlg-mini-stepper" data-mlg-stepper>' +
        '<button type="button" class="mlg-stepper-btn" data-mlg-decrease aria-label="Decrease quantity">−</button>' +
        '<span class="mlg-stepper-count" data-mlg-count>' + qty + '</span>' +
        '<button type="button" class="mlg-stepper-btn" data-mlg-increase aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function updateCartBubble(itemCount) {
    var selectors = [
      '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span',
      '[data-cart-count]',
      '.cart-count'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = itemCount;
        el.classList.add('mlg-cart-bump');
        setTimeout(function () { el.classList.remove('mlg-cart-bump'); }, 400);
      });
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { itemCount: itemCount } }));
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) { throw err; });
      }
      return response.json();
    });
  }

  function changeLineQuantity(variantId, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function initCard(card) {
    var wrap = card.querySelector('.mlg-card-actions');
    if (!wrap) return;

    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    var slot = card.querySelector('[data-mlg-cart-slot]');
    var buyBtn = card.querySelector('[data-mlg-buynow]');
    var qty = 0;

    function bindAddButton() {
      var addBtn = slot.querySelector('[data-mlg-add]');
      if (!addBtn) return;
      addBtn.addEventListener('click', function () {
        addBtn.classList.add('is-loading');
        addToCart(variantId, 1)
          .then(function () {
            qty = 1;
            slot.innerHTML = stepperHtml(qty);
            bindStepperButtons();
            return fetchCart();
          })
          .then(function (cart) { updateCartBubble(cart.item_count); })
          .catch(function () {
            addBtn.classList.remove('is-loading');
            alert('This item could not be added to the cart. Please try again.');
          });
      });
    }

    function bindStepperButtons() {
      var increaseBtn = slot.querySelector('[data-mlg-increase]');
      var decreaseBtn = slot.querySelector('[data-mlg-decrease]');
      var countEl = slot.querySelector('[data-mlg-count]');

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          qty += 1;
          if (countEl) countEl.textContent = qty;
          changeLineQuantity(variantId, qty).then(function (cart) {
            updateCartBubble(cart.item_count);
          });
        });
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          qty = Math.max(0, qty - 1);
          changeLineQuantity(variantId, qty).then(function (cart) {
            updateCartBubble(cart.item_count);
            if (qty === 0) {
              slot.innerHTML = ADD_BTN_HTML;
              bindAddButton();
            } else if (countEl) {
              countEl.textContent = qty;
            }
          });
        });
      }
    }

    if (slot) bindAddButton();

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        buyBtn.disabled = true;
        addToCart(variantId, 1)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            alert('This item could not be added to the cart. Please try again.');
            buyBtn.disabled = false;
          });
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-mlg-card]').forEach(initCard);
    (root || document).querySelectorAll('[data-mlg-carousel]').forEach(initCarousel);
  }

  function initCarousel(wrap) {
    var track = wrap.querySelector('[data-mlg-track]');
    var prevBtn = wrap.querySelector('[data-mlg-prev]');
    var nextBtn = wrap.querySelector('[data-mlg-next]');
    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.mlg-card');
      var amount = card ? card.getBoundingClientRect().width + 28 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();